export const ORDER_STATUS = {
  NEW: 'new',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  SHIPPING: 'shipping',
  PARTIALLY_DELIVERED: 'partially_delivered',
  DELIVERED: 'delivered',
  RETURNED: 'returned',
  PARTIALLY_RETURNED: 'partially_returned',
  EXCHANGED: 'exchanged',
  COMPLETED: 'completed',
  CANCELED: 'canceled'
}

export const ORDER_STATUS_OPTIONS = [
  {
    value: ORDER_STATUS.NEW,
    label: 'New'
  },
  {
    value: ORDER_STATUS.CONFIRMED,
    label: 'Confirmed'
  },
  {
    value: ORDER_STATUS.PROCESSING,
    label: 'Processing'
  },
  {
    value: ORDER_STATUS.SHIPPING,
    label: 'Shipping'
  },
  {
    value: ORDER_STATUS.PARTIALLY_DELIVERED,
    label: 'Partially Delivered'
  },
  {
    value: ORDER_STATUS.DELIVERED,
    label: 'Delivered'
  },
  {
    value: ORDER_STATUS.PARTIALLY_RETURNED,
    label: 'Partially Returned'
  },
  {
    value: ORDER_STATUS.RETURNED,
    label: 'Returned'
  },
  {
    value: ORDER_STATUS.COMPLETED,
    label: 'Completed'
  },
  {
    value: ORDER_STATUS.CANCELED,
    label: 'Canceled'
  }
]

export const orderStatusLabel = {
  New: 'new',
  Confirmed: 'confirmed',
  Processing: 'processing',
  Shipping: 'shipping',
  'Partially Returned': 'partially_returned',
  Delivered: 'delivered',
  Returned: 'returned',
  'Partially Delivered': 'partially_delivered',
  Completed: 'completed',
  Canceled: 'canceled'
}
